import { render } from "./ErrorBox.vue?vue&type=template&id=38aae0cf&scoped=true"
const script = {}

import "./ErrorBox.vue?vue&type=style&index=0&id=38aae0cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38aae0cf"

export default script